import { createSlice } from '@reduxjs/toolkit';
import { fetchStreetList } from './thunk';

/* =========================
   TYPES
========================= */

export type StreetType = {
    _id: string;
    street: string;
    isActive: boolean;
    area: {
        _id: string;
        area: string;
        state: string;
        city: string;
    };
};

export type PaginationType = {
    totalCount: number;
    page: number;
    pageSize: number;
};

export type FilterType = {
    isActive: boolean | null;
    state: string;
    city: string;
    area: string;
    search: string;
    sortBy: any;
    sortOrder: any;
    totalCount: number;
    page: number;
    limit: number;
};

interface StreetState {
    streetList: StreetType[];
    filterData: FilterType;
    paginationData: PaginationType;
    loading: {
        streetList: boolean;
    };
}

/* =========================
   INITIAL STATE
========================= */

const initialState: StreetState = {
    loading: {
        streetList: false,
    },
    filterData: {
        isActive: null,
        state: "",
        city: "",
        area: "",
        search: "",
        sortBy: "",
        sortOrder: null,
        totalCount: 0,
        page: 1,
        limit: 50,
    },
    paginationData: {
        totalCount: 0,
        page: 1,
        pageSize: 50,
    },
    streetList: [],
};

/* =========================
   SLICE
========================= */

const StreetSlice = createSlice({
    name: 'street',
    initialState,
    reducers: {
        setStreetList(state, action) {
            state.streetList = action.payload;
        },
        setStreetFilterData(state, action) {
            state.filterData = action.payload;
        },
        resetStreetFilters(state) {
            state.filterData = {
                ...initialState.filterData,
            };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStreetList.pending, (state) => {
                state.loading.streetList = true;
            })
            .addCase(fetchStreetList.fulfilled, (state, action) => {
                state.loading.streetList = false;

                state.streetList = action.payload?.data || [];

                state.filterData = {
                    ...state.filterData,
                    ...action.payload?.filterData,
                };

                state.paginationData = {
                    totalCount: action.payload?.total || 0,
                    page: action.payload?.page || 1,
                    pageSize: action.payload?.limit || 50,
                };
            })
            .addCase(fetchStreetList.rejected, (state) => {
                state.loading.streetList = false;
            });
    },
});

export const {
    setStreetList,
    setStreetFilterData,
    resetStreetFilters,
} = StreetSlice.actions;

export default StreetSlice.reducer;
